export const ActivityAction = {
    FrontendError: 'frontend.error',
    RateSyncRequested: 'rate.sync.requested',
    RateSynced: 'rate.synced',
    StoUploaded: 'sto.uploaded',
    AgentInvitationSent: 'agent.invitation.sent',
    AgentInvitationDeclined: 'agent.invitation.declined',
    AgentInvitationConnected: 'agent.invitation.connected',
    AgentDeleted: 'agent.deleted',
    CrmEnquiryQuarantineReleased: 'crm.enquiry.quarantine_released',
    CrmLeadSourceCreated: 'crm.lead_source.created',
    CrmLeadSourceAddressRotated: 'crm.lead_source.address_rotated',
    CrmInboundCapExceeded: 'crm.inbound.cap_exceeded',
} as const;

export type ActivityActionValue = (typeof ActivityAction)[keyof typeof ActivityAction];
